import gql from "graphql-tag";

import {parsePerseusArticle} from "@khan/component-perseus";
import {injectWidgets} from "@khan/component-perseus/perseus";
// eslint-disable-next-line no-restricted-imports -- TODO(FEI-7051): switch to useGql
import type {ApolloGqlClient} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {sanitizeTex, setPromptVariable} from "@khan/guide-core-helpers";

// eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
import type {AITeacherTools_ArticleDetailsType} from "./__graphql-types__/index.ts";
import {setSharedDetails, unsetSharedDetails} from "./shared-details.ts";

export const ARTICLE_DETAILS_QUERY: GqlOperation<
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_ArticleDetailsType["response"],
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_ArticleDetailsType["variables"]
> = gqlOp(gql`
    query AITeacherTools_ArticleDetails($articleId: String) {
        articleById(id: $articleId) {
            id
            translatedTitle
            defaultUrlPath
            translatedPerseusContent
            parentTopic {
                id
                domainSlug
                allLearnableContent(includeUnlisted: false) {
                    id
                    translatedTitle
                    defaultUrlPath
                }
            }
        }
    }
`);

export async function loadArticleDetails(
    gqlClient: ApolloGqlClient,
    articleId: string,
) {
    const response = await gqlClient.query(ARTICLE_DETAILS_QUERY, {
        variables: {articleId},
        fetchPolicy: "cache-first",
    });

    const article = response.data?.articleById;
    if (!article) {
        return;
    }

    const domain = article.parentTopic?.domainSlug ?? "";
    if (domain) {
        setPromptVariable("domain", domain);
    }

    setPromptVariable("contentTitle", article.translatedTitle || "");

    const perseusContent = parsePerseusArticle(
        article.translatedPerseusContent || "[]",
    );

    const context = sanitizeTex(
        perseusContent
            .map(({content, widgets}) => injectWidgets(content, widgets))
            .join("\n"),
    );

    // For historical reasons, we set the vaguely named 'context' variable,
    // but we also set a more descriptively-named variable:
    setPromptVariable("context", context);
    setPromptVariable("articleContent", context);

    setSharedDetails(article);
}

export function unloadArticleDetails() {
    ["contentTitle", "context", "domain", "articleContent"].forEach(
        (variable) => {
            setPromptVariable(variable, null);
        },
    );
    unsetSharedDetails();
}
